const EVENT_ACCEPT = 'Accept'
const EVENT_CLICK = 'Click'
const EVENT_OPEN = 'Open'
const EVENT_ERROR = 'Error'
const EVENT_SUBMIT = 'Submit'
const EVENT_VIEW = 'View'

const ADDRESS_SUGGESTION_VIEW = `${EVENT_VIEW} - Address Suggestion -`
const ADDRESS_SUGGESTION_ACCEPT = `${EVENT_ACCEPT} - Address Suggestion -`

export const SEGMENT_CDN_URL = 'https://cdn.segment.com'

export default Object.freeze({
  EVENTS: {
    INIT: {
      ViewInquiryPage: `${EVENT_VIEW} - Inquiry (CAFE)`,
      ViewInquiryResultsPage: `${EVENT_VIEW} - Card Application (CAFE)`,
      ViewApplicationInfoPage: `${EVENT_VIEW} - Application Info Page (CAFE)`,
      ViewInformedDeliveryLandingPage: `${EVENT_VIEW} - Informed Delivery Landing Page (CAFE)`,
      ViewAppLookupPage: `${EVENT_VIEW} - Application Lookup Page (CAFE)`,
      ViewDmLookupPage: `${EVENT_VIEW} - DM Lookup Page (CAFE)`,
      ViewOutOfWalletPage: `${EVENT_VIEW} - Intro Page (CAFE)`,
      ViewSocurePage: `${EVENT_VIEW} - Socure Intro Page (CAFE)`,
      ViewDecisioningPage: `${EVENT_VIEW} - Decisioning Page (CAFE)`,
      ViewInReviewPage: `${EVENT_VIEW} - In Review Page (CAFE)`,
      ViewCreditKarmaPage: `${EVENT_VIEW} - CK Landing Page (CAFE)`,
      ViewAppDownloadPage: `${EVENT_VIEW} - App Download Page (CAFE)`,
      ViewFrozenPausedPage: `${EVENT_VIEW} - Frozen Paused Page (CAFE)`,
      ViewCfuPage: `${EVENT_VIEW} - CFU Intro Page (CAFE)`,
      ViewErrorPage: `${EVENT_VIEW} - Top Level Error Page (CAFE)`,
      ViewPoiPage: `${EVENT_VIEW} - POI Intro Page (CAFE)`,
      ViewSecuredCardFunding: `${EVENT_VIEW} - Secured Card Funding Page (CAFE)`,
      ViewCatchAllPage: `${EVENT_VIEW} - Catch-All Page (CAFE)`,
      ViewLineSelectionPage: `${EVENT_VIEW} - Secured Card Line Selection Page (CAFE)`,
      ViewIdConflictPage: `${EVENT_VIEW} - ID Conflict Page (CAFE)`,
      ViewLandingPage: `${EVENT_VIEW} - Landing Page (CAFE)`,
      ViewCounterOfferPage: `${EVENT_VIEW} - Counter Offer Intro Page (CAFE)`,
      ViewCounterOfferAcceptancePage: `${EVENT_VIEW} - Counter Offer Acceptance Page (CAFE)`,
    },
    ADDRESS_VALIDATION: {
      InvalidAddressError: `${EVENT_ERROR} - Invalid Address (CAFE)`,
      AddressSuggestionStreetAddressView: `${ADDRESS_SUGGESTION_VIEW} Street Address`,
      AddressSuggestionCityView: `${ADDRESS_SUGGESTION_VIEW} City`,
      AddressSuggestionStateView: `${ADDRESS_SUGGESTION_VIEW} State`,
      AddressSuggestionZipCodeView: `${ADDRESS_SUGGESTION_VIEW} Zip Code`,
      AddressSuggestionStreetAddressAccept: `${ADDRESS_SUGGESTION_ACCEPT} Street Address`,
      AddressSuggestionCityAccept: `${ADDRESS_SUGGESTION_ACCEPT} City`,
      AddressSuggestionStateAccept: `${ADDRESS_SUGGESTION_ACCEPT} State`,
      AddressSuggestionZipCodeAccept: `${ADDRESS_SUGGESTION_ACCEPT} Zip Code`,
    },
    EMAIL_VALIDATION: {
      EmailSuggestionAccept: `${EVENT_ACCEPT} - Email Suggestion (CAFE)`,
    },
    PHONE_NUMBER_VALIDATION: {
      InvalidPhoneNumberError: `${EVENT_ERROR} - Invalid Phone Number (CAFE)`,
    },
    VIEW_OUTCOME: {
      AppCoreApplicationApproved: `${EVENT_VIEW} - Approval (CAFE)`,
      ApplicationDeclined: `${EVENT_VIEW} - Decline Page, AAN (CAFE)`,
    },
    ERROR: {
      ApplicationDeclinedAanViewPdfFailure: `${EVENT_VIEW} - Server Failure on AAN Page (CAFE)`,
      GenericFormValidationError: `${EVENT_ERROR} - Form Validation (CAFE)`,
      SubmitCfuSnapshotFailure: `${EVENT_ERROR} - Failure on CFU Snapshot Submission (CAFE)`,
      OptOutError: `${EVENT_ERROR} - Failure on Opt Out (CAFE)`,
      SubmitPoiDocumentsFailure: `${EVENT_ERROR} - Failure on Document Submission (CAFE)`,
    },
    VIEW_FORM: {
      GenericErrorPage: `${EVENT_VIEW} - 404 (CAFE)`,
      NeedMoreTime: `${EVENT_VIEW} - Need More Time`,
      InvalidStateMessage: `${EVENT_VIEW} - Invalid State`,
    },
    SUBMIT_FORM: {
      InquiryResponseFailure: `${EVENT_ERROR} - Inquiry Submission Response Failure (CAFE)`,
      SubmitInquiry: `${EVENT_SUBMIT} - Inquiry (CAFE)`,
      InquiryResultsSubmit: `${EVENT_SUBMIT} - Card Application (CAFE)`,
      SubmitDirectMailLookup: `${EVENT_SUBMIT} - Direct Mail Lookup (CAFE)`,
      SubmitInformedDeliveryLookup: `${EVENT_SUBMIT} - Informed Delivery Lookup (CAFE)`,
      SubmitOutOfWalletForm: `${EVENT_SUBMIT} (CAFE)`,
      SubmitApplicationLookup: `${EVENT_SUBMIT} - Application Lookup Page (CAFE)`,
      SecuredCardFundingSubmitDeposit: `${EVENT_SUBMIT} - Secured Card Funding Deposit (CAFE)`,
      SubmitPOIDocuments: `${EVENT_SUBMIT} - Documents (CAFE)`,
      SubmitPassword: `${EVENT_SUBMIT} - Password (CAFE)`,
    },
    SUBMIT_APP: {
      SubmitApplication: `${EVENT_SUBMIT} - Application (CAFE)`,
    },
    SUBMIT_APP_ERROR: {
      ApplicationResponseFailure: `${EVENT_ERROR} - Application Submission Response Failure (CAFE)`,
    },
    MAIL_LANDING_PAGE: {
      View: `${EVENT_VIEW} - Page (CAFE)`,
      Submit: `${EVENT_SUBMIT} - Form (CAFE)`,
      NotFoundError: `${EVENT_ERROR} - Invalid Code (CAFE)`,
      ServerError: `${EVENT_ERROR} - Server Error (CAFE)`,
    },
    INTERACTION: {
      ConsentToEcom: `${EVENT_CLICK} - Electronic Communications Checkbox (CAFE)`,
      NoConsentToEcom: `Un-click - Electronic Communications Checkbox (CAFE)`,
      ConsentToContact: `${EVENT_CLICK} - Consent to be Contacted Checkbox (CAFE)`,
      NoConsentToContact: `Un-click - Consent to be Contacted Checkbox (CAFE)`,
      ConsentToCreditPull: `${EVENT_CLICK} - Consent to Credit Pull Checkbox (CAFE)`,
      AgreeToAllDisclosuresClick: `${EVENT_CLICK} - Agree to All Disclosures (CAFE)`,
      ClickLogIn: `${EVENT_CLICK} - Account Log In Button (CAFE)`,
      AppDownloadWebLogin: `${EVENT_CLICK} - App Download Page Web Login (CAFE)`,
      AppDownloadIOSDownload: `${EVENT_CLICK} - App Download Page iOS Download (CAFE)`,
      AppDownloadAndroidDownload: `${EVENT_CLICK} - App Download Page Android Download (CAFE)`,
      ExperianLinkClick: `${EVENT_CLICK} - Experian Link (CAFE)`,
      TransUnionLinkClick: `${EVENT_CLICK} - TransUnion Link (CAFE)`,
      ClickPlaidLink: `${EVENT_CLICK} - Plaid Link (CAFE)`,
      ClickOptOut: `${EVENT_CLICK} - Opt Out (CAFE)`,
      OpenPlaidModal: `${EVENT_OPEN} - Plaid Modal (CAFE)`,
      ClickCreditProtectionLearnMoreLink: `${EVENT_CLICK} - Credit Protection Modal (CAFE)`,
      ClickAddDocument: `${EVENT_CLICK} - Add Document (CAFE)`,
      ClickAddFile: `${EVENT_CLICK} - Add File (CAFE)`,
      CreditProtectionOptIn: `Credit Protection - Enrolled (CAFE)`,
      CreditProtectionOptOut: `Credit Protection - Not Enrolled (CAFE)`,
      SetFormErrorFocusClick: `${EVENT_CLICK} - Correct Errors (CAFE)`,
      ClickAanPrintButton: `${EVENT_CLICK} - AAN Print Button (CAFE)`,
      ClickSecuredCardGotoAccountButton: `${EVENT_CLICK} - Go to Account Button (CAFE)`,
      ClickThawCompleteButton: `${EVENT_CLICK} - Thaw Complete Button (CAFE)`,
      ClickLineSelectionNextButton: `${EVENT_CLICK} - Line Selection Next Button (CAFE)`,
      ClickIdConflictLogInButton: `${EVENT_CLICK} - ID Conflict Login Button (CAFE)`,
      ClickGetSetUpButton: `${EVENT_CLICK} - Get Set Up Button (CAFE)`,
      ClickUnlockHigherLineButton: `${EVENT_CLICK} - Unlock Higher Line Button (CAFE)`,
      ClickSkipButton: `${EVENT_CLICK} - Skip Button (CAFE)`,
      ClickSkipForNowButton: `${EVENT_CLICK} - Skip for Now Button (CAFE)`,
      ClickCta: `${EVENT_CLICK} - CTA (CAFE)`,
      ClickCredibleCheckRates: `${EVENT_CLICK} - Credible Check My Rates Button (CAFE)`,
      ClickCredibleLink: `${EVENT_CLICK} - Credible Link (CAFE)`,
      ClickCredibleTrustpilotLink: `${EVENT_CLICK} - Credible Trustpilot Link (CAFE)`,
    },
    PROCESS: {
      CraStatusComplete: `CRA Status - Complete (CAFE)`,
      CraStatusError: `CRA Status - Error (CAFE)`,
      CraStatusInProgress: `CRA Status - In Progress (CAFE)`,
      FeatureFlagAssignment: 'Feature Flag Assignment',
      PlaidError: `Plaid Error -`,
      PlaidSuccess: `Plaid Success - Plaid Modal (CAFE)`,
      SecuredCardFundingComplete: `Secured Card Funding Deposit - Success (CAFE)`,
      SecuredCardFundingInProgress: `Secured Card Funding Deposit - In Progress (CAFE)`,
      SecuredCardFundingFailed: `Secured Card Funding Deposit - Failed (CAFE)`,
      SocureError: `Socure Error -`,
      SocureProgress: `Socure Progress -`,
      SocureSuccess: `Socure Success -`,
    },
  },
})
